import { FC } from "react";

export const CycleIcon: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className || ""}`}
    >
      <mask
        id="mask0_4317_42548"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4317_42548)">
        <path
          d="M7.85 21.125C6.11667 20.325 4.70833 19.1167 3.625 17.5C2.54167 15.8833 2 14.0583 2 12.025C2 11.5917 2.02083 11.1667 2.0625 10.75C2.10417 10.3333 2.175 9.925 2.275 9.525L1.125 10.2L0.125 8.475L4.9 5.725L7.65 10.475L5.9 11.475L4.55 9.125C4.36667 9.575 4.22917 10.0417 4.1375 10.525C4.04583 11.0083 4 11.5083 4 12.025C4 13.6417 4.44167 15.1125 5.325 16.4375C6.20833 17.7625 7.38333 18.7417 8.85 19.375L7.85 21.125ZM15.5 9V7H18.225C17.4583 6.05 16.5333 5.3125 15.45 4.7875C14.3667 4.2625 13.2167 4 12 4C11.0833 4 10.2167 4.14167 9.4 4.425C8.58333 4.70833 7.83333 5.10833 7.15 5.625L6.15 3.875C6.98333 3.29167 7.89167 2.83333 8.875 2.5C9.85833 2.16667 10.9 2 12 2C13.3167 2 14.575 2.24583 15.775 2.7375C16.975 3.22917 18.05 3.94167 19 4.875V3.5H21V9H15.5ZM14.85 24L10.075 21.25L12.825 16.5L14.55 17.5L13.125 19.95C15.0917 19.6667 16.7292 18.775 18.0375 17.275C19.3458 15.775 20 14.0167 20 12C20 11.8167 19.9958 11.6458 19.9875 11.4875C19.9792 11.3292 19.9583 11.1667 19.925 11H21.95C21.9667 11.1667 21.9792 11.3292 21.9875 11.4875C21.9958 11.6458 22 11.8167 22 12C22 14.25 21.3292 16.2625 19.9875 18.0375C18.6458 19.8125 16.9 21.0083 14.75 21.625L15.85 22.275L14.85 24Z"
          fill="#007DFF"
        />
      </g>
    </svg>
  );
};
